
import { mapGetters } from 'vuex'
import Quickadd from './quickadd.vue'
import Price from '@/components/price/price'
import LolePicture from '@/components/picture/lole-picture'
export default {
  name: 'PDPBundles',
  components: { Price, LolePicture, Quickadd },
  props: {
    product: {
      type: Object,
      required: true,
    },
    wording: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      products: [],
    }
  },
  computed: {
    ...mapGetters({
      vxCurrency: 'currency/getCurrency',
    }),
  },
  watch: {
    async product() {
      this.products = []
      await this.fetchProducts()
    },
  },
  methods: {
    async fetchProducts() {
      const bundleRaw = this.wording?.bundles?.find(({ products }) =>
        products?.includes(
          `${this.product?.internal_type}-${this.product?.internal_color_code}`
        )
      )
      const parsedInteralTypes = this.parseInternalTypes(bundleRaw?.products)
      if (parsedInteralTypes?.length > 0)
        this.products = await this.fetchProductsFromShopify(
          parsedInteralTypes,
          this.vxCurrency
        )
    },
    parseInternalTypes(products) {
      const raw = products?.replace(/\s/g, '')?.toUpperCase()?.split(',') || []
      const currentProduct = `${this.product?.internal_type}-${this.product?.internal_color_code}`
      const filteredRaw = raw.filter((item) => item !== currentProduct)
      return filteredRaw.map((product) => {
        const [internalType, color] = product.split('-')
        return {
          colors: color,
          internal_type: internalType,
        }
      })
    },
    getSecondMediaTypeImage(product) {
      if (product?.medias?.length > 0)
        return product.medias.filter((media) => {
          return media.type === 'image'
        })[1]
      return null
    },
  },
}
